import React from 'react'
import Footer from '../Footer/Footer'
import Head from './Head'
import classes from "./LandingPage.module.css"
import LandingPageMain from './LandingPageMain'
import LandingPageNav from './LandingPageNav'
import Platform from './Platform'
import Testimonial from './Testimonial'
import Why from "./Why"


const LandingPage = () => {
  return (
    <div className={classes.LandingPage}>
        <LandingPageNav/>
        <Head/>
        <LandingPageMain/>
        <Why/>
        <Platform/>
        <Testimonial/>
        <div className={classes.footer}>
        <Footer />
        </div>
    </div>
  )
}

export default LandingPage